export class BydLocalStorage {
  /**
   * Get an item from the local storage with the given key &
   * Converts the Object Notation (JSON) string into an object with JSON.parse.
   *
   * @param keyName the item keyName
   * @returns the value of the keyName typed with `T`. null is returned if no match is found.
   */
  static getParsedItem<T>(keyName: string): T {
    return JSON.parse(BydLocalStorage.getItem(keyName));
  }

  /**
   * Get an item from the local storage with the given key.
   *
   * @param keyName the item keyName
   * @returns the value of the keyName typed with `T`. null is returned if no match is found.
   */
  static getItem(keyName: string): string {
    return localStorage.getItem(keyName);
  }

  /**
   * Set an item from the local storage with the given key.
   *
   * @param keyName the item key name
   * @param value the value
   */
  static setStringifyItem<T>(keyName: string, value: T): void {
    BydLocalStorage.setItem(keyName, JSON.stringify(value));
  }

  /**
   * Set an item from the local storage with the given key.
   *
   * @param keyName the item key name
   * @param value the value
   */
  static setItem(keyName: string, value: string): void {
    localStorage.setItem(keyName, value);
  }

  /**
   * Remove an item from the local storage with the given key.
   *
   * @param keyName the item key name
   * @param The item keyName
   */
  static removeItem(keyName: string): void {
    localStorage.removeItem(keyName);
  }
}
